'use client';

import Icon from './Icon';
import svg from 'sprites/human-rehabilitation.svg';

export default function IconHumanRehabilitation({
  className = 'w-16 h-5 fill-none stroke-brown'
}: {
  className?: string;
}) {
  return <Icon id={svg.id} className={className} />;
}
